import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import * as styles from './style';
import { Checkbox } from '../../../styles/customComponents';

const renderCheckbox = (option, selectOption, fatherId) => {
  return (
    <Checkbox
      id={`check-item-${fatherId || ''}${option.id}`}
      name={`check-item-${fatherId || ''}${option.id}`}
      checked={option.checked}
      someChecked={option.someChecked}
      disabled={!!option.disabled}
      onClick={!option.disabled ? () => selectOption({ option, fatherId }) : null}
      customStyles={{ paddingLeft: 0 }}
    />
  );
};

const Item = ({ option, selectOption, fatherId, leftCheckbox, selectAll }) => {
  return (
    <styles.ItemContainer leftCheckbox={leftCheckbox} selectAll={selectAll}>
      {leftCheckbox ? (
        <Fragment>
          {renderCheckbox(option, selectOption, fatherId)}
          <styles.Text>{option.name}</styles.Text>
        </Fragment>
      ) : (
        <Fragment>
          <styles.Text>{option.name}</styles.Text>
          {renderCheckbox(option, selectOption, fatherId)}
        </Fragment>
      )}
    </styles.ItemContainer>
  );
};

Item.propTypes = {
  option: PropTypes.object,
  selectOption: PropTypes.func,
  fatherId: PropTypes.any,
  leftCheckbox: PropTypes.bool,
  selectAll: PropTypes.bool,
};

Item.defaultProps = {
  leftCheckbox: false,
  selectAll: false,
};

export default Item;



// WEBPACK FOOTER //
// ./src/components/GenericSelectList/Item/index.js